import { getDateAggregationKey } from "../../../utils/getDateAggregationKey";

interface Props {
    summaryStats: any[];
    alignMode: "none" | "left" | "right";
    getColor: (i: number) => string;
    hoveredKey: string | null;
}

export function MultiSummaryStats({ summaryStats, alignMode, getColor, hoveredKey }: Props) {
    if (!summaryStats || summaryStats.length === 0) return null;

    return (
        <div style={{ marginTop: "2rem", overflowX: "auto" }}>
            <h3 style={{ marginBottom: "0.5rem" }}>Series Summary</h3>
            <table
                style={{
                    borderCollapse: "collapse",
                    minWidth: "800px",
                    textAlign: "right",
                    fontSize: "0.9rem",
                }}
            >
                <thead>
                    <tr>
                        <th style={{ textAlign: "left", borderBottom: "2px solid var(--surface-glass-border)", padding: "6px" }}>
                            Metric
                        </th>
                        {summaryStats.map((s, i) => (
                            <th
                                key={s?.name}
                                style={{
                                    borderBottom: "2px solid var(--surface-glass-border)",
                                    padding: "6px",
                                    color: getColor(i),
                                    textAlign: "center",
                                }}
                            >
                                {s?.name}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[
                        { label: "Count (N)", key: "n" },
                        { label: "First Value", key: "first" },
                        { label: "Last Value", key: "last" },
                        { label: "Δ (Last−First)", key: "delta" },
                        { label: "%Δ", key: "pctChange" },
                        { label: "Max", key: "max" },
                        { label: "X @ Max", key: "maxX" },
                        { label: "Min", key: "min" },
                        { label: "X @ Min", key: "minX" },
                        { label: "Range (Max−Min)", key: "range" },
                        { label: "Mean", key: "mean" },
                        { label: "Median", key: "median" },
                        { label: "Std Dev", key: "std" },
                        { label: "CV (Std/|Mean|)", key: "cv" },
                    ].map((row) => (
                        <tr key={row.key}>
                            <td
                                style={{
                                    textAlign: "left",
                                    borderBottom: "1px solid var(--surface-glass-border)",
                                    padding: "4px 6px",
                                    fontWeight: 500,
                                }}
                            >
                                {row.label}
                            </td>
                            {summaryStats.map((s, i) => {
                                const value = (s as any)[row.key];
                                const formatted =
                                    typeof value === "number"
                                        ? isFinite(value)
                                            ? value.toFixed(3)
                                            : "-"
                                        : alignMode === "none"
                                            ? value
                                                ? getDateAggregationKey(value, "datetime")
                                                : "-"
                                            : value;
                                return (
                                    <td
                                        key={i}
                                        style={{
                                            borderBottom: "1px solid var(--surface-glass-border)",
                                            padding: "4px 6px",
                                            opacity: hoveredKey && hoveredKey !== s?.name ? 0.4 : 1,
                                        }}
                                    >
                                        {formatted}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

